<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'

defineProps<{
  title: string
  description: string
}>()
</script>

<template>
  <Box direction="col" align="center" justify="center" class="tws__hero">
    <Box flex align="center" justify="center" class="tws__hero-icon">
      <Text is="span" class="tws__hero-emoji">🔗</Text>
    </Box>
    <Text type="display-lg" align="center" is="h2" class="tws__hero-title">{{ title }}</Text>
    <Text type="caption" color="muted" align="center" class="tws__hero-desc">
      {{ description }}
    </Text>
  </Box>
</template>

<style scoped>
.tws__hero {
  flex: 1;
  padding: 1.25rem;
  text-align: center;
  min-height: 280px;
}

.tws__hero-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: var(--p-surface-0);
  border: 1px solid var(--p-content-border-color);
  margin-bottom: 1.25rem;
  flex-shrink: 0;
}

.tws__hero-emoji {
  font-size: 24px;
  line-height: 1;
}

.tws__hero-title {
  letter-spacing: -0.3px;
  margin: 0 0 0.75rem;
  line-height: 1.27;
}

.tws__hero-desc {
  line-height: 18px;
  max-width: 288px;
  margin: 0;
}
</style>
